import { Maybe } from "types/Maybe"

type ButtonVariant = string

const mapButtonVariant = function (passedColor: Maybe<string>): ButtonVariant {
  if (!passedColor) return "primary"

  type ButtonVariantMapType = Record<string, string>

  const buttonVariantMap: ButtonVariantMapType = {
    aqua: "primaryAqua",
    navy: "primary",
    sky: "primarySky",
    transparent: "secondary",
    white: "primaryWhite",
  }

  return buttonVariantMap[passedColor]
}

export default mapButtonVariant
